import { render, staticRenderFns } from "./DepartmentMaster.vue?vue&type=template&id=42d17558&scoped=true&"
import script from "./DepartmentMaster.vue?vue&type=script&lang=js&"
export * from "./DepartmentMaster.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentMaster.vue?vue&type=style&index=0&id=42d17558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d17558",
  null
  
)

export default component.exports